<template>
  <list-layout :tableTools='false' v-if="!isNewProduct" >
    <template slot="header" >
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ $t('products.header') }}</h2>
        <el-form-item prop="products" class="flex-1">
        </el-form-item>
      </div>
    </template>
    <template slot='table-core'>
      <base-table-pagination 
        :total='pagination.total'
        :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize'
        @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'
      ></base-table-pagination>
      <div class="flex flex-row space-x-2">
        <base-button-responsive size="xs" class="w-full md:w-auto" icon="plus" :text="$t('invoices.invoices_issuing.step4.create_product')" @click="toggleNewProduct" :loading="isGeneralLoading" />
        <div class="flex flex-row w-100 gap-4">
          <base-table-searches v-if="false" @toggleSearchesDialog="toggleSearchesDialog" />
          <base-table-search @toggleFilters="toggleFilters" :disabled="isNewProduct" />
        </div>
      </div>
    </template>
    <template slot='table-tags'>
      <base-table-filter-tags hide-save :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot='table-component' >
      <kendo-grid-component 
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        :inEditField="selectedField"
        :expandField="selectedField"
        value-key="idProducto"
        @datastatechange='dataStateChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
          <template v-slot:kendorowdetail="{ scope, selected, inEdit, save }">
            <div class="custom-detail-row flex flex-row gap-2 w-full">
              <div class="flex flex-row gap-2 w-full">
                <div class="w-full">
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="selected"/>{{ $t('invoices.invoices_issuing.step4.cantidad') }}</label>
                    <el-input clearable class="w-full" v-model="scope.cantidad" type="number" size="mini" :disabled="!inEdit" @input="e => controlCantidad(scope, e, save)" />
                  </div>
                  <base-ro-input class="mt-2" mini :label="$t('app.subtotal')" :data="formatNumberWithDefault(scope.subtotal)" />
                </div>
                <div class="w-full">
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.descuento') }}</label>
                    <el-input clearable class="w-full" v-model="scope.descuento" type="number" size="mini" :disabled="!inEdit" @input="e => controlDescuento(scope, e, save)" />
                  </div>
                  <div class="mt-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.cuota_descuento') }}</label>
                    <el-input clearable class="w-full" v-model="scope.cuota" type="number" size="mini" :disabled="!inEdit" @input="e => controlCuota(scope, e, save)" />
                  </div>
                </div>
              </div>
              <div class="w-full">
                <div class="flex flex-row gap-2">
                  <div class="w-full" >
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="selected"/>{{ $t('impuestos.entity_name') }}</label>
                    <!-- Quitar [0], cambiar [e] por e y agregar atributo múltiple para admitir varios impuestos -->
                    <base-el-select clearable class="w-full" v-model="scope.Taxes[0]" size="mini" value-key="idImpuesto" :option-value="taxValue" :options="scope.Impuestos" :disabled="!inEdit" @input="e => controlImpuestos(scope, [e], save)" />
                  </div>
                  <div class="w-full">
                      <base-ro-input class="flex-1" mini :label="$t('app.total_no_tax')" :data="formatNumberWithDefault(scope.total)" />
                  </div>
                </div>
                <div class="flex flex-row gap-2 mt-2">
                  <base-ro-input class="flex-1" mini :label="$t('invoices.invoices_issuing.tax_cuota')" :data="formatNumberWithDefault(scope.Taxes[0].cuota)" />
                  <base-ro-input class="flex-1" mini :label="$t('app.total')" :data="formatNumberWithDefault(scope.totalConImpuesto)" />
                </div>
              </div>
            </div>
          </template>
      </kendo-grid-component>
    </template>
    <template slot='layout-extend'>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog :numberSearches="numberSearches" :idVista="idVista" :dialogOpen="saveSearchDialog"
        :tags="tags" @toggleDialog="toggleDialogSearches" @applyDialog="applySearchHandler" />
      <filter-panel-searches ref="filterPanelSearches" :idVista="idVista" :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel" @togglePanel="toggleSearchesDialog" @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches" />
    </template>
  </list-layout>

  <!--  ----Diálogo nuevo producto----  -->
  <detail-layout v-else>
    <template slot="main">
      <div class="form-wrapper" v-if="isNewProduct">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-col w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('products.ItemDescription') }}</label>
                <el-form-item prop="ItemDescription">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.ItemDescription"
                    maxlength='2500'
                    type="textarea"
                    :rows="3"
                  />
                </el-form-item>
              </div>
            </div>

            <div class="flex flex-col md:flex-row items-center gap-x-2">
              <div class="lg:mb-2 w-full">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('products.ArticleCode') }}</label>
                  <el-form-item prop="ArticleCode">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.ArticleCode"
                      maxlength='20'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2 w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.invoices_issuing.step4.unity_product') }}</label>
                <el-form-item prop="UnitOfMeasure">
                  <base-el-select class="w-full" :options="tiposUnidadesMedida" v-model="form.UnitOfMeasure" filterable clearable/>
                </el-form-item>
              </div>

              <div class="lg:mb-2 w-full">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.invoices_issuing.step4.unity_price') }}</label>
                  <el-form-item prop="UnitPriceWithoutTax">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.UnitPriceWithoutTax"
                      type="number"
                      maxlength="9">
                      <template slot="append">€</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <base-button v-if="false" mode="secondary-phantom-blue" class="flex-row-reverse" :text="$t('app.save')" @click="newProduct('ruleForm')" />
          </div>


          <!-- LINK TAXES TO PRODUCT -->
          <div v-for="(impuesto, key) in form.impuestos" :key="key" class="mb-2 mt-2 flex flex-col items-center w-full relative">
            <base-button-icon
              v-if="form.impuestos.length > 1"
              @click="removeTax(key)"
              name="cross"
              mode="primary-phantom"
              class="-top-3 -right-3 absolute"
              custom="dark:border dark:border-darkblue-600"
            />
            <div class="w-full p-4 bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border">
              <div class="px-2 w-full lg:mb-0">
                <label class="text-sm font-semibold text-secondary-600 block mb-2"><base-obligatory-icon/>{{ $t('impuestos.entity_name') }}</label>
                <el-form-item :prop="'impuestos.'+ key + '.name'" :rules="generalRules.general">
                  <el-select class="w-full" 
                    clearable
                    filterable
                    allow-create
                    v-model="form.impuestos[key].name" 
                    :placeholder="$t('invoices.invoices_issuing.step4.create_tax')"
                    :loading="isGeneralLoading" >
                    <el-option
                      v-for="opt in taxesList"
                      :key="opt.idImpuesto"
                      :label="opt.Name"
                      :value="`${opt.Name}:${opt.idImpuesto}`">
                    </el-option>
                  </el-select> 
                </el-form-item>
              </div>
              <div v-if="!isNewTax(key)" class="flex flex-col md:flex-row items-center gap-x-2">
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-2"><base-obligatory-icon/>{{ $t('invoices.invoices_issuing.tipo_impuesto') }}</label>
                  <el-form-item :prop="'impuestos.'+ key + '.taxType'" :rules="isNewTax(key) ? rules :generalRules.general">
                    <base-el-select 
                      class="w-full" 
                      :options="tiposCodigoImpuesto" 
                      v-model="form.impuestos[key].taxType"
                      filterable 
                      clearable/>
                  </el-form-item>
                </div>
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-2"><base-obligatory-icon/>{{ $t('impuestos.TaxRate') }}</label>
                  <el-form-item :prop="'impuestos.'+ key + '.taxRate'" :rules="isNewTax(key) ? rules :generalRules.general">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.impuestos[key].taxRate"
                      type="number"
                      maxlength="9">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>  
            </div>
          </div>
          <div v-if="false" class="flex flex-row items-center">
            <base-button-responsive
              v-if="!tooMuchTaxes"
              mode="primary-phantom"
              :text="$t('invoices.invoices_issuing.step4.add_tax')"
              icon="plus"
              @click="addTax()"
              :loading="isGeneralLoading"
            />
          </div>
        </el-form>
      </div>
    </template>
      

  </detail-layout>

</template>
<script>
import { i18n } from '@/i18n'
import { DoubleUpToEightDecimalType } from '@/utils/regex'
import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

import getNestedValue from '@/services/functions/getNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
import { getImpuestosSimple } from '@/services/configurations/getImpuestosSimple' 
import { getProductsWithTaxesPag } from '@/services/configurations/getProductsWithTaxesPag'

import DetailLayout from '@/components/layout/DetailLayout.vue'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/Step4ProductsFilter.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'


export default {
  name: 'step4-product-table',
  components: {
    // Loading,
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    DetailLayout
  },
  props: {
    value: Array,
    ruleForm: Object,
    idCliente: [Number, String]
  },
  data () {
    return {
      // Searches
      idVista: 66,
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      multipleFilters: TIPOS_FILTER_MULTIPLE,
      spanish: true,
      vuexnamespace: 'invoicesIssuing/4/products',
      selectedField: 'selected',
      isNewProduct: false,
      filterPanel: false,
      loadingDataTable: false,
      numMaxTaxes: 5,
      form: this.getDefaultForm(),
      data: [],
      selected: [],
      taxesList: [],
      rules: {
        ItemDescription: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        UnitOfMeasure: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        UnitPriceWithoutTax: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(rule.message))
              } else if (value < 0) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          },
        ],
      },
      generalRules: {
        general: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        taxRate: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          { validator: this.isTaxRateValid, trigger: ['blur', 'change'] }
        ],
      }
    }
  },
  computed: {
    tooMuchTaxes: function () {
      return this.form.impuestos.length >= this.numMaxTaxes
    },
    getIdCliente: function () {
      return this.$store.getters['invoicesIssuing/form'].issuer.IdCliente
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.kendo.dataResult ? this.kendo.dataResult.data.length : 0
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    tiposUnidadesMedida: function () {
      return this.$store.getters['config/TIPOS_UNIDADES_MEDIDA']
    },
    tiposCodigoImpuesto: function () {
      // Excluimos el IRPF
      return this.$store.getters['config/TIPOS_CODIGO_IMPUESTO'].filter(element => element.id !== '04')
    },
  },
  watch: {},
  async mounted () {
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.taxesList = await this.getTaxesByClient(this.getIdCliente)
    this.data = await this.applyFilters()
  },
  methods: {
    isTaxRateValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      const valueFloat = parseFloat(value)
      if (valueFloat < 0 || valueFloat > 100 || !DoubleUpToEightDecimalType.test(valueFloat)) {
        callback(new Error(i18n.t('validation.taxrate')))
      } else {
        callback()
      }
    },
    getDefaultForm: function () {
      return {
        id: -1,
        ItemDescription: '',
        UnitOfMeasure: '01',
        UnitPriceWithoutTax: '',
        ArticleCode: '',
        idCliente: '',
        impuestos: [
          {
            idImpuesto: -1,
            name: '',
            taxType: '',
            taxRate: ''
          }
        ]
      }
    },
    addTax () {
      if (this.form.impuestos.length >= this.numMaxTaxes) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.max_taxes', { maxTaxes: this.numMaxTaxes }), 'warning')
        return
      }
      const newTax = {
        idImpuesto: -1,
        name: '',
        taxType: '',
        taxRate: '',
      }
      this.form.impuestos.push(newTax)
    },
    removeTax (index) {
      if (this.form.impuestos) this.form.impuestos.splice((index), 1)
    },
    isNewTax: function (key) {
      const idImpuesto = parseInt(this.form.impuestos[key].name.split(':')[1])
      const tax = this.taxesList.some(x => x.idImpuesto === idImpuesto)
      if (tax && this.form.impuestos[key].name !== '') {
        this.form.impuestos[key].idImpuesto = idImpuesto
        return true
      }
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    toggleNewProduct: async function () {
      this.isNewProduct = !this.isNewProduct
      this.$emit('applyToggle')
      this.data = await this.applyFilters()
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      const params = {
        ItemDescription: data.ItemDescription ? data.ItemDescription.value : null,
        UnitOfMeasure: data.UnitOfMeasure ? data.UnitOfMeasure.value : null,
        UnitPriceWithoutTaxMin: data.UnitPriceWithoutTaxMin ? data.UnitPriceWithoutTaxMin.value : null,
        UnitPriceWithoutTaxMax: data.UnitPriceWithoutTaxMax ? data.UnitPriceWithoutTaxMax.value : null,
        ArticleCode: data.ArticleCode ? data.ArticleCode.value : null,
      }
      if (this.role !== '' && [3, 7, 8].includes(this.role)) {
        params.idCliente = this.idCliente || null
      }
      return params
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.Respuesta
      // Quitar string vacieo para admitir múltiple
      data.forEach(x => setNestedValue('Taxes', x, [''], true))

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getProductsWithTaxesPag(orders, params)
      if (data.blnError === true) {
        this.doFeedback(`${data.msgError} [${data.codError}]`)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const index = tag.at(-1)
      const tagName = this.multipleFilters.find(x => new RegExp('^' + x.NombreTag + '\\d*$').test(tag[0]))?.NombreTag
      if (tagName) {
        if (Number.isInteger(index) && Array.isArray(filter[tagName].value) && index > -1 && 
          index < filter[tagName]?.value.length && filter[tagName]?.value.length > 1) {
          filter[tagName].value.splice(index, 1)
        } else {
          delete filter[tagName]
        }
      } else {
        delete filter[tag[0]]
      }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    onHeaderSelectionChange: function ({ selected }) {
      this.selected = selected
      this.$emit('input', selected)
      // this.$nextTick(() => this.validate(undefined, false))
    },
    onSelectionChange: function ({ selected, dataItem, isSelected }) {
      if (isSelected) {
        ['subtotal', 'descuento', 'cuota', 'total', 'totalConImpuesto'].forEach(key => {
          const currentValue = getNestedValue(key, dataItem)
          if (currentValue === undefined || currentValue === null) {
            setNestedValue(key, dataItem, '', true)
          }
        })
        if (!dataItem.Taxes[0] && dataItem.Impuestos?.length) {
          setNestedValue('Taxes[0]', dataItem, dataItem.Impuestos[0], true)
        }
        if (dataItem.editDescuento === undefined || dataItem.editDescuento === null) {
          setNestedValue('editDescuento', dataItem, false, true)
        }
        if (dataItem.cantidad === undefined || dataItem.cantidad === null) {
          setNestedValue('cantidad', dataItem, '1', true)
          this.controlCantidad(dataItem, dataItem.cantidad)
        }
      }
      this.selected = selected
      this.$emit('input', selected)
      // this.$nextTick(() => this.validate(undefined, false))
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    validate: function () {
      if (this.ruleForm) {
        this.ruleForm.validateField('products')
      }
    },
    getTaxesByClient: async function (clientId) {
      const params = { 
        idCliente: clientId,
        taxType: '04'
      }
      const response = await getImpuestosSimple(params)
      if (response.blnError === true) {
        this.doFeedback(`${response.msgError} [${response.codError}]`)
      } else {
        return response.Respuesta
      }
    },
    controlCantidad: function (dataItem, cantidad, save) {
      if (this.isFalsy(cantidad)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.need_cantidad'))
      } else if (cantidad === 0) {
        cantidad = ''
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_cantidad'))
      } else if (cantidad.includes('.') && dataItem.UnitOfMeasure.includes('01')) {
        cantidad = ''
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_product'))
      }
      this.calculateSubTotal(dataItem, cantidad)
      if (dataItem.editDescuento && this.isNotFalsy(dataItem.descuento)) {
        this.controlDescuento(dataItem, dataItem.descuento, save)
      } else if (!dataItem.editDescuento && this.isNotFalsy(dataItem.cuota)) {
        this.controlCuota(dataItem, dataItem.cuota, save)
      } else {
        this.calculateTotal(dataItem)
        this.calculateTotalConImpuesto(dataItem, save) 
      }
    },
    controlCuota: function (dataItem, cuota, save) {
      var valid = true
      if (cuota !== '' && cuota !== 0 && dataItem.subtotal !== 0 && ((cuota < 0 && dataItem.subtotal > 0) || (cuota > 0 && dataItem.subtotal < 0))) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_cuota', { max: dataItem.subtotal }))
        cuota = ''
        valid = false
      }
      const descuento = cuota !== '' && dataItem.subtotal !== '' ? cuota * 100 / dataItem.subtotal : ''
      setNestedValue('descuento', dataItem, descuento, true)
      setNestedValue('editDescuento', dataItem, (cuota !== '' ? false : (valid ? '' : null)), true)
      this.calculateTotal(dataItem)
      this.calculateTotalConImpuesto(dataItem, save)
    },
    controlDescuento: function (dataItem, descuento, save) {
      var valid = true
      if (descuento !== '' && (descuento < 0 || descuento > 100)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_discount'))
        descuento = ''
        valid = false
      }
      const cuota = descuento !== '' && dataItem.subtotal !== '' ? dataItem.subtotal * descuento / 100 : ''
      setNestedValue('cuota', dataItem, cuota, true)
      setNestedValue('editDescuento', dataItem, (descuento !== '' ? true : (valid ? '' : null)), true)
      this.calculateTotal(dataItem)
      this.calculateTotalConImpuesto(dataItem, save)
    },
    controlImpuestos: function (dataItem, taxes = [], save) {
      if (this.isFalsy(taxes) && getNestedValue(this.selectedField, dataItem) && this.isNotFalsy(dataItem.cantidad)) {
        this.doFeedback(i18n.t('feedback.error.obligatory_field_error', { field: i18n.t('impuestos.entity_name').toLowerCase() }))
      } 
      if (taxes.some(x => x.TaxRate === 0)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.warning_zero_tax_rate'), 'warning')
      }
      this.calculateTotalConImpuesto(dataItem, save)
    },
    calculateSubTotal: function (dataItem, cantidad = dataItem.cantidad) {
      if (this.isNotFalsy(cantidad)) {
        const subtotal = dataItem.UnitPriceWithoutTax * cantidad
        setNestedValue('subtotal', dataItem, subtotal, true)
      } else {
        setNestedValue('subtotal', dataItem, '', true)
      }
    },
    calculateTotal: function (dataItem) {
      if (this.isNotFalsy(dataItem.subtotal) && (dataItem.editDescuento !== null)) {
        const total = (dataItem.subtotal - (dataItem.cuota || 0))
        setNestedValue('total', dataItem, total, true)
      } else {
        setNestedValue('total', dataItem, '', true)
      }
    },
    calculateTotalConImpuesto: function (dataItem, save) {
      if (this.isNotFalsy(dataItem.total) && this.isNotFalsy(dataItem.Taxes)) {
        const total = dataItem.total || 0
        dataItem.Taxes.forEach(tax => setNestedValue('cuota', tax, total * (tax.TaxRate || 0) / 100))
        const cuotaImpuesto = dataItem.Taxes.map(tax => tax.cuota || 0).reduce((acc, x) => acc + x, 0)
        const totalConImpuesto = total + cuotaImpuesto
        setNestedValue('totalConImpuesto', dataItem, totalConImpuesto, true)
      } else {
        setNestedValue('totalConImpuesto', dataItem, '', true)
      }
      if (typeof save === 'function') {
        save(true)
      }
    },
    formatNumberWithDefault: function (number, format = 'currency_8', vdefault = ' - ') {
      if (this.isFalsy(number)) {
        return vdefault
      }
      return i18n.n(number, format)
    },
    taxValue: function (option) {
      return option
    },
    isNotFalsy: function (value) {
      if (Array.isArray(value)) {
        return value.length && value.some(x => this.isNotFalsy(x))
      }
      return ![undefined, null, false, ''].includes(value)
    },
    isFalsy: function (value) {
      return !this.isNotFalsy(value)
    },
    // newProduct: function (formName) {
    //   this.$store.commit('setIsLoading', true)
    //   this.$refs[formName].validate(async (valid) => {
    //     if (valid) {
    //       const params = {
    //         idCliente: this.getIdCliente,
    //         ItemDescription: this.form.ItemDescription,
    //         UnitOfMeasure: this.form.UnitOfMeasure,
    //         UnitPriceWithoutTax: this.form.UnitPriceWithoutTax,
    //         ArticleCode: this.form.ArticleCode,
    //         Impuestos: [
    //           {
    //             Name: this.form.Name,
    //             TaxType: this.form.TaxType,
    //             TaxRate: this.form.TaxRate
    //           }
    //         ]
    //       }
    //       this.$emit('applyToggle', params)
    //       // const response = await createProductWithTaxes(params)
    //       // if (response.blnError === true) {
    //       //   this.doFeedback(`${response.msgError} [${response.codError}]`)
    //       // } else {
    //       //   this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
    //       this.form = this.getDefaultForm()
    //       this.data = await this.applyFilters()
    //       this.isNewProduct = false
    //       // }
    //     } else {
    //       this.doFeedback(i18n.t('feedback.error.process_data_error'))
    //     }
    //     this.$store.commit('setIsLoading', false)
    //   })
    // }
  }
}
</script>
<style>
.k-animation-container.k-animation-container-relative.k-animation-container-shown {
  z-index: 9999;
}
</style>
<style scoped>
@media (min-width: 1024px) {
  ::v-deep .lg\:max-w-detail {
    max-width: unset;
  }
}
</style>
